import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { HomeAteneoComponent } from './components/home-ateneo/home-ateneo.component';
import { LocationsComponent } from './components/locations/locations.component';
import {AirfalComponent} from './components/airfal/airfal.component';
import {FloorplansComponent} from './components/floorplans/floorplans.component';
import {DevicesComponent} from './components/devices/devices.component';
import {IndicatorsComponent} from './components/indicators/indicators.component';
import {IndicatorsSelectionComponent} from './components/indicators/indicators-selection/indicators-selection.component';
import {WarningsComponent} from './components/warnings/warnings.component';
import {HomeConfigurationComponent} from './components/home-configuration/home-configuration.component';
import {UsersComponent} from './components/users/users.component';
import {ReglasComponent} from './components/reglas/reglas.component';
import {ProfileComponent} from "./components/profile/profile.component";
import {FadeComponent} from "./components/fade/fade.component";
import {SelectFloorplanComponent} from "./components/select-floorplan/select-floorplan.component";
import {ContactMessageComponent} from "./components/contact-message/contact-message.component";
import {AlertsComponent} from "./components/alerts/alerts.component";
import {LimitsComponent} from "./components/limits/limits.component";
import {ZonesComponent} from "./components/zones/zones.component";
import {OtaComponent} from "./components/ota/ota.component";
import {IndicatorsPresencesComponent} from "./components/indicators/indicators-presences/indicators-presences.component";
import {IndicatorsSensorsComponent} from "./components/indicators/indicators-sensors/indicators-sensors.component";
import {AuthGuard} from "./guard/auth.guard";
import {AutotestComponent} from "./components/autotest/autotest.component";
import {ReportsComponent} from "./components/reports/reports.component";
import {ParametersComponent} from "./components/parameters/parameters.component";

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeAteneoComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    }  },
  { path: 'home_configuration', component: HomeConfigurationComponent, canActivate: [AuthGuard],
    data: {
      role: ['Configuración', 'Administrador']
    } },
  { path: 'locations', component: LocationsComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    } },
  { path: 'indicators', component: IndicatorsComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    }  },
  { path: 'indicators_selection', component: IndicatorsSelectionComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    }  },
  { path: 'floorplans', component: FloorplansComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    }  },
  { path: 'select_floorplan', component: SelectFloorplanComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    }  },
  { path: 'airfal', component: AirfalComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    }  },
  { path: 'contact_message', component: ContactMessageComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    } },
  { path: 'devices', component: DevicesComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    } },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard],
    data: {
      role: ['Configuración', 'Administrador']
    } },
  { path: 'rules', component: ReglasComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    } },
  { path: 'profiles', component: FadeComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    } },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    } },
  { path: 'alerts', component: AlertsComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    } },
  { path: 'limits', component: LimitsComponent, canActivate: [AuthGuard],
    data: {
      role: ['Configuración', 'Administrador']
    } },
  { path: 'zones', component: ZonesComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    }  },
  { path: 'ota', component: OtaComponent, canActivate: [AuthGuard],
    data: {
      role: ['Configuración', 'Administrador']
    } },
  { path: 'autotest', component: AutotestComponent, canActivate: [AuthGuard],
    data: {
      role: ['Configuración', 'Administrador']
    } },
  { path: 'indicators-presences', component: IndicatorsPresencesComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    } },
  { path: 'indicators-sensors', component: IndicatorsSensorsComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    } },
  { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard],
    data: {
      role: ['Ateneo', 'Configuración', 'Administrador']
    } },
  { path: 'parameters', component: ParametersComponent, canActivate: [AuthGuard],
    data: {
      role: ['Configuración', 'Administrador']
    } },
  { path: '**', redirectTo: '/login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
